import { lazyLoadComponentFactory } from "@Components/Modules/Helpers";

export default lazyLoadComponentFactory(
    () => import(/* webpackChunkName: "mobile-register" */ "./MobileRegister"),
);
